import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8",
  code: "ka",
  messages: {
    alert: {
      close: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0"
    },
    authForm: {
      hidePassword: "\u10DE\u10D0\u10E0\u10DD\u10DA\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10DA\u10D5\u10D0",
      showPassword: "\u10DE\u10D0\u10E0\u10DD\u10DA\u10D8\u10E1 \u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10D0",
      submit: "\u10D2\u10D0\u10D2\u10E0\u10EB\u10D4\u10DA\u10D4\u10D1\u10D0"
    },
    banner: {
      close: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0"
    },
    calendar: {
      nextMonth: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10D7\u10D5\u10D4",
      nextYear: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10EC\u10D4\u10DA\u10D8",
      prevMonth: "\u10EC\u10D8\u10DC\u10D0 \u10D7\u10D5\u10D4",
      prevYear: "\u10EC\u10D8\u10DC\u10D0 \u10EC\u10D4\u10DA\u10D8"
    },
    carousel: {
      dots: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E1\u10DA\u10D0\u10D8\u10D3\u10D8 \u10E1\u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10DA\u10D0\u10D3",
      goto: "\u10D2\u10D0\u10D3\u10D0\u10E1\u10D5\u10DA\u10D0 \u10E1\u10DA\u10D0\u10D8\u10D3 {slide}-\u10D6\u10D4",
      next: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8",
      prev: "\u10EC\u10D8\u10DC\u10D0"
    },
    chatPrompt: {
      placeholder: "\u10D3\u10D0\u10EC\u10D4\u10E0\u10D4\u10D7 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10DB\u10D4\u10E1\u10D8\u10EF\u10D8 \u10D0\u10E5..."
    },
    chatPromptSubmit: {
      label: "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0"
    },
    colorMode: {
      dark: "\u10D1\u10DC\u10D4\u10DA\u10D8",
      light: "\u10DC\u10D0\u10D7\u10D4\u10DA\u10D8",
      switchToDark: "\u10D1\u10DC\u10D4\u10DA \u10E0\u10D4\u10EF\u10D8\u10DB\u10D6\u10D4 \u10D2\u10D0\u10D3\u10D0\u10E1\u10D5\u10DA\u10D0",
      switchToLight: "\u10DC\u10D0\u10D7\u10D4\u10DA \u10E0\u10D4\u10EF\u10D8\u10DB\u10D6\u10D4 \u10D2\u10D0\u10D3\u10D0\u10E1\u10D5\u10DA\u10D0",
      system: "\u10E1\u10D8\u10E1\u10E2\u10D4\u10DB\u10E3\u10E0\u10D8"
    },
    commandPalette: {
      back: "\u10E3\u10D9\u10D0\u10DC",
      close: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0",
      noData: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1",
      noMatch: "\u10E8\u10D4\u10E1\u10D0\u10E2\u10E7\u10D5\u10D8\u10E1\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1",
      placeholder: "\u10E9\u10D0\u10EC\u10D4\u10E0\u10D4\u10D7 \u10D1\u10E0\u10EB\u10D0\u10DC\u10D4\u10D1\u10D0 \u10D0\u10DC \u10EB\u10D8\u10D4\u10D1\u10D0..."
    },
    contentSearch: {
      links: "\u10D1\u10DB\u10E3\u10DA\u10D4\u10D1\u10D8",
      theme: "\u10D7\u10D4\u10DB\u10D0"
    },
    contentSearchButton: {
      label: "\u10EB\u10D8\u10D4\u10D1\u10D0..."
    },
    contentToc: {
      title: "\u10D0\u10DB \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4"
    },
    dashboardSearch: {
      theme: "\u10D7\u10D4\u10DB\u10D0"
    },
    dashboardSearchButton: {
      label: "\u10EB\u10D8\u10D4\u10D1\u10D0..."
    },
    dashboardSidebarCollapse: {
      collapse: "\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10D7\u10D8 \u10D6\u10DD\u10DA\u10D8\u10E1 \u10E9\u10D0\u10D9\u10D4\u10EA\u10D5\u10D0",
      expand: "\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10D7\u10D8 \u10D6\u10DD\u10DA\u10D8\u10E1 \u10D2\u10D0\u10E8\u10DA\u10D0"
    },
    dashboardSidebarToggle: {
      close: "\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10D7\u10D8 \u10D6\u10DD\u10DA\u10D8\u10E1 \u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0",
      open: "\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10D7\u10D8 \u10D6\u10DD\u10DA\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0"
    },
    error: {
      // While "home" translates as "სახლი", I chose to use "მთავარი" (meaning "main") as contextually this sounds better.
      // If any Georgian prefers literal translation, please submit patch.
      clear: "\u10DB\u10D7\u10D0\u10D5\u10D0\u10E0\u10D6\u10D4 \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D0"
    },
    fileUpload: {
      removeFile: "\u10DB\u10DD\u10D0\u10E8\u10DD\u10E0\u10D4 {filename}"
    },
    header: {
      close: "\u10DB\u10D4\u10DC\u10D8\u10E3\u10E1 \u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0",
      open: "\u10DB\u10D4\u10DC\u10D8\u10E3\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0"
    },
    inputMenu: {
      create: '\u10E8\u10D4\u10E5\u10DB\u10D4\u10DC\u10D8 "{label}"',
      noData: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1",
      noMatch: "\u10E8\u10D4\u10E1\u10D0\u10E2\u10E7\u10D5\u10D8\u10E1\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    inputNumber: {
      decrement: "\u10D3\u10D0\u10D9\u10DA\u10D4\u10D1\u10D0",
      increment: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    modal: {
      close: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0"
    },
    pricingTable: {
      caption: "\u10E4\u10D0\u10E1\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10D3\u10D0\u10E0\u10D4\u10D1\u10D0"
    },
    prose: {
      codeCollapse: {
        closeText: "\u10E9\u10D0\u10D9\u10D4\u10EA\u10D5\u10D0",
        name: "\u10D9\u10DD\u10D3\u10D8",
        openText: "\u10D2\u10D0\u10E8\u10DA\u10D0"
      },
      collapsible: {
        closeText: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0",
        name: "\u10D7\u10D5\u10D8\u10E1\u10D4\u10D1\u10D4\u10D1\u10D8",
        openText: "\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10D0"
      },
      pre: {
        copy: "\u10D9\u10DD\u10D3\u10D8\u10E1 \u10D9\u10DD\u10DE\u10D8\u10E0\u10D4\u10D1\u10D0 \u10D1\u10E3\u10E4\u10D4\u10E0\u10E8\u10D8"
      }
    },
    selectMenu: {
      create: '\u10D3\u10D0\u10D0\u10DB\u10D0\u10E2\u10D4 "{label}"',
      // "Create" translates as "შექმნა", but since we are simply adding new choice, creating sounds wrong, thus I chose to use "დაამატე", meaning "add".
      noData: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1",
      noMatch: "\u10E8\u10D4\u10E1\u10D0\u10E2\u10E7\u10D5\u10D8\u10E1\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1",
      search: "\u10EB\u10D8\u10D4\u10D1\u10D0..."
    },
    slideover: {
      close: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0"
    },
    table: {
      noData: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    toast: {
      close: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0"
    }
  }
});
